import ModalDestructiveConfirm from 'components/ModalDestructiveConfirm';
import {FC} from 'react';
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {useBackend} from 'state/backend';
import {FormFields} from 'types/utils';
import {onApiError} from 'utils/request-axios/utils';

import {useDeleteTag} from '../services';
import {Tag} from '../types';

type FormData = FormFields<{id: number}>;

type DeleteTagModalProps = {
    isOpen: boolean;
    onClose: () => void;
    tag: Tag;
};

const DeleteTagModal: FC<DeleteTagModalProps> = ({isOpen, onClose, tag}) => {
    const {t} = useTranslation('Partner.TagsSettings');
    const {refreshData} = useBackend();
    const {mutateAsync} = useDeleteTag();
    const methods = useForm<FormData>();

    const onConfirmDelete = () => {
        mutateAsync({id: tag.id})
            .then(() => {
                refreshData(window.Urls.partner_tags_view());
                onClose();
            })
            .catch((error) => {
                onApiError(methods)(error);
            });
    };

    return (
        <ModalDestructiveConfirm
            header={t('deleteTag')}
            isOpen={isOpen}
            onCancel={onClose}
            onConfirm={onConfirmDelete}
        >
            <p className="break-words">
                {tag.itemCount === 0 &&
                    t('deleteMessageNoItem', {name: tag.name})}
                {tag.itemCount === 1 &&
                    t('deleteMessageOneItem', {name: tag.name})}
                {tag.itemCount > 1 &&
                    t('deleteMessageManyItems', {
                        count: tag.itemCount,
                        name: tag.name,
                    })}
            </p>
        </ModalDestructiveConfirm>
    );
};

export default DeleteTagModal;
